import Swal from 'sweetalert2';
import {DateTime} from 'luxon';
import React from 'react';
import ReactQuill from 'react-quill';
import axios from 'axios';
import {constance} from './constance/constance';
import {config} from "./config/config";
import {MenuInterface} from "../interface/menu.interface";

export const common = {
    alert: function (title: any, text: any, icon: any) {
        Swal.fire({
            title: title,
            text: text,
            icon: icon,
            confirmButtonColor: '#468cf4',
        });
    },
    confirm: function (title: any, text: any, icon: any, callback: any, parmas: any) {
        Swal.fire({
            title: title,
            text: text,
            icon: icon,
            showCancelButton: true, // cancel버튼 보이기. 기본은 원래 없음
            confirmButtonColor: '#3085d6', // confrim 버튼 색깔 지정
            cancelButtonColor: '#d33', // cancel 버튼 색깔 지정
            confirmButtonText: '확인', // confirm 버튼 텍스트 지정
            cancelButtonText: '취소', // cancel 버튼 텍스트 지정
            reverseButtons: true, // 버튼 순서 거꾸로
            preConfirm: () => {
                return callback(parmas)
            }
        })
    },
    isEmpty: (value: string | number | object): boolean => {
        if (value === null) {
            return true;
        } else if (typeof value !== 'number' && value === '') {
            return true;
        } else if (typeof value === 'undefined' || value === undefined) {
            return true;
        } else if (value !== null && typeof value === 'object' && !Object.keys(value).length) {
            return true;
        } else {
            return false;
        }
    },
    getWeekDayText: (v: number, isMobile: boolean) => {
        let result = '';
        switch (v) {
            case 1:
                result = isMobile ? '월' : '월요일';
                break;
            case 2:
                result = isMobile ? '화' : '화요일';
                break;
            case 3:
                result = isMobile ? '수' : '수요일';
                break;
            case 4:
                result = isMobile ? '목' : '목요일';
                break;
            case 5:
                result = isMobile ? '금' : '금요일';
                break;
            case 6:
                result = isMobile ? '토' : '토요일';
                break;
            case 7:
                result = isMobile ? '일' : '일요일';
                break;
        }

        return result;
    },

    getTimeFormat: (v: any) => {
        if (v == null) {
            return '';
        }
        return DateTime.fromMillis(new Date(v).getTime()).toFormat('yyyy-MM-dd  HH:mm:ss');
    },

    getTimeFormatYMD: (v: any) => {
        if (v == null) {
            return '';
        }
        return DateTime.fromMillis(new Date(v).getTime()).toFormat('yyyy-MM-dd');
    },

    getQuery: () => {
        const query = new URLSearchParams(window.location.search);
        let id: any = query.get('id');
        let no = query.get('no');
        let workplace: any = query.get('workplace');
        if (workplace == null || workplace == 'null') {
            workplace = 0;
        } else {
            workplace = Number(workplace);
        }

        let page: any = query.get('page');
        page = page == null || page == 'null' ? 1 : page;

        let club: any = query.get(config.clubId);
        club = club == null || club == 'null' ? '' : club;

        let department: any = query.get(config.departmentId);
        department = department == null || department == 'null' ? '' : department;

        let keyword: any = query.get('keyword');
        keyword = keyword == null || keyword == 'null' ? '' : keyword;

        let searchType: any = query.get('search-type');
        searchType = searchType == null || searchType == 'null' ? 'title' : searchType;

        let fmId: any = query.get('fid');
        fmId = fmId == null || fmId == 'null' ? null : fmId;

        let limit: any = query.get('limit');
        limit = limit == null || limit == 'null' ? 10 : limit;

        if (common.isEmpty(id)) {
            id = '';
        }
        return {id, no, workplace, page, club, department, keyword, searchType, fmId, limit};
    },

    getMenuObject: (id: string | null) => {
        let result: any = null;
        for (let menu of config.menu) {
            if (id == menu.id) {
                console.log('menu', menu);
                result = menu;
                break;
            }
            if (menu.subMenu) {
                for (let subMenu of menu.subMenu) {
                    if (id == subMenu.id) {
                        console.log('subMenu', subMenu);
                        result = subMenu;
                        break;
                    }
                }
            }
        }
        return result;
    },
    imageHandler: (QuillRef: React.MutableRefObject<ReactQuill | undefined>) => {
        // 이미지를 업로드 하기 위한 함수
        const imageHandler = () => {
            // 파일을 업로드 하기 위한 input 태그 생성
            const input = document.createElement('input');
            const formData = new FormData();
            let url = '';

            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');
            input.click();

            // 파일이 input 태그에 담기면 실행 될 함수
            input.onchange = async () => {
                const file = input.files;
                if (file !== null) {
                    formData.append('files', file[0]);

                    try {

                        axios({
                            method: 'post',
                            url: constance.api.imageUploadUrl,
                            data: formData,
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        }).then(value => {
                            console.log(value);
                            if (value.data.success) {
                                url = value.data.url;
                                // 커서의 위치를 알고 해당 위치에 이미지 태그를 넣어주는 코드
                                // 해당 DOM의 데이터가 필요하기에 useRef를 사용한다.
                                const range = QuillRef.current?.getEditor().getSelection()?.index;
                                if (range !== null && range !== undefined) {
                                    let quill = QuillRef.current?.getEditor();
                                    quill?.setSelection(range, 1);
                                    quill?.clipboard.dangerouslyPasteHTML(
                                        range,
                                        `<img src=${url} alt="이미지" />`,
                                    );
                                }
                            }
                        }).catch(reason => {
                            console.log(reason);
                        });
                    } catch (error) {
                    }
                }
            };
        };
        return imageHandler;
    },

    getMenuData: (menu: MenuInterface, setState: any, state: any) => {
        /* 동호회 게시판일 경우 클럽 리스트 조회 */
        if (config.clubId === menu.id) {
            axios.get(constance.api.getClubList).then(value => {
                console.log('constance.api.getClubList');
                console.log(value);
                setState({
                    ...state,
                    clubList: value.data.clubList
                })
            })
        } else if (config.departmentId === menu.id) {
            axios.get(constance.api.getDepartmentList).then(value => {
                console.log('constance.api.getDepartmentList');
                setState({
                    ...state,
                    departmentList: value.data.departmentList,
                })
            })
        }
    },

    setCookie: (cookieName: string, value: string, minutes: number) => {
        const exdate = new Date();
        exdate.setMinutes(exdate.getMinutes() + minutes);
        const cookie_value = escape(value) + '; path=/; ' + ((minutes == null) ? '' : '; expires=' + exdate.toUTCString());
        document.cookie = cookieName + '=' + cookie_value;
    },

    getCookie(cookieName: string) {
        let x, y;
        let val = document.cookie.split(';');
        for (let i = 0; i < val.length; i++) {
            x = val[i].substr(0, val[i].indexOf('='));
            y = val[i].substr(val[i].indexOf('=') + 1);
            x = x.replace(/^\s+|\s+$/g, '');
            // 앞과 뒤의 공백 제거하기
            if (x === cookieName) {
                return unescape(y);
                // unescape로 디코딩 후 값 리턴
            }
        }
    },
};

